import type { FaireProductEntity } from "../../entity_types/product";

export const p_mam2qhfxdf: FaireProductEntity = {
  token: "p_mam2qhfxdf",
  type: "product",
  name: "Worthy Bracelet",
  brandToken: "b_1mhxgl7b",
  brandName: "Dear Heart",
  imageUrl:
    "https://cdn.faire.com/fastly/91c122ec60dec703ffcae4d2d0af5839512b8a66a9dd77dd664d0679039cbbbc.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b686f416a79154f4b1a0e6ca546a9e851fc4e52f68771dfb302fa9899fa3c323.jpeg",
    "https://cdn.faire.com/fastly/a58348f39f47fcfd2c8add18523ee910d86c753c938bf67d4dd2b4b309618b20.jpeg",
    "https://cdn.faire.com/fastly/68cea606c0d34c94a5ac37541ccac480bbcff0799ab61f7ff0a82014499d01c2.jpeg",
    "https://cdn.faire.com/fastly/ac829aa5f07342068afc35c9ca6da62f4e142263185174dbe4d5f34b21187957.jpeg",
    "https://cdn.faire.com/fastly/3bb9bbb39afa9c5c16dde2c0879be27aa252254be1cd9905218b4af2c1752f37.jpeg",
    "https://cdn.faire.com/fastly/0bfed2aed6564083007aa1f747bf80d90d700aa977354653276883f2f5015208.jpeg",
    "https://cdn.faire.com/fastly/a340e2858d88a6c2b380dd6406006e7906e7c8a77d13264a2184145c7ecb20d0.jpeg",
    "https://cdn.faire.com/fastly/e6498584334ea9cd956c213ba9d0dfe65ba7304251f63002be9cee4aaa431b9a.jpeg",
  ],
  priceDollars: 12,
  description:
    'Psalm 119:32 “I run in the path of your commandments, for you have set my heart free.”\n\nLuke 12:6-7 “Are not five sparrows sold for two pennies? Yet not one of them is forgotten by God. Indeed, the very hairs of your head are all numbered. Don’t be afraid; you are worth more than many sparrows.”\n\nHe calls you worthy.\n\nYour value is solely found in the one who created you. Don’t search for it in anyone or anything else. You are not worthy because you have earned it, you are worthy simply because He says you are. Surrender striving and receive the love and grace He freely gives. To Him, you were worth dying for.\n\n𝐃𝐞𝐭𝐚𝐢𝐥𝐬:\n•beaded stretch bracelet\n• 6.75" before stretching- size fits most\n•verse reference on attached gold tag\n•polaroid inspired packaging\n•personal note compartment inside\n•verse details on back',
  tags: [],
  msrpDollars: 25,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:49:03.004Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
